import React, { Component } from 'react';
import { Button, Divider, Form } from 'semantic-ui-react';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { find } from 'lodash';
import * as classnames from 'classnames';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import {
  Tech3Radio,
  Tech3RCheckbox,
  Tech3Select
} from '../../../../../../../components/FormElements';
import { required } from '../../../../../../../lib/FormValidators';

const occurrenceTransformationFormName = 'occurrenceSignal';
const occurrenceEventFormSelector = formValueSelector(occurrenceTransformationFormName);

class TransformationForm extends Component {
  constructor(props) {
    super(props);

    this.setTransformation = this.setTransformation.bind(this);
    // this.setSignalId = this.setSignalId.bind(this);
  }

  setTransformation(id) {
    this.props.changeFieldValue('transformation_id', id);
  }

  render() {
    const self = this;
    /*
    let signals = [];
    let hardwares = [];
    let softwares = [];
    let versions = []; */
    let transformation_names = [];
    if (!(this.props.transformations == null)) {
      transformation_names = this.props.transformations.map((transformation, i) => {
        return {
          key: `transform_${transformation.id}`,
          text: transformation.name,
          value: transformation.id
        };
      });
    }

    /* if (this.props.selectedEquipment) {
      signals = this.props.selectedEquipment.signals.map((signal, i) => {
        const dimensions = signal.dimensions.map((dimension, k) => {
          return (
            <Field
              key={dimension.id}
              component={Tech3RCheckbox}
              name="dimensions"
              isArray
              idCheck={`dimension_${dimension.id}`}
              checkValue={dimension.id}
              validate={[required]}
              label={dimension.name}
            />
          );
        });

        const dimensionsClasses = classnames({
          dimensionContainer: true,
          hidden: !self.props.selectedSignal || self.props.selectedSignal.id !== signal.id
        });

        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={signal.id}
                component={Tech3Radio}
                name="signal_id"
                idRadio={`signal_${signal.id}`}
                radioValue={signal.id}
                label={signal.name}
                validate={[required]}
                onChange={(event, newValue, previousValue) => {
                  if (newValue === signal.id) {
                    this.setSignalId(newValue);
                  }
                }}
              />
            </div>
            <div className={dimensionsClasses}>{dimensions}</div>
          </div>
        );
      });
    }

    if (this.props.selectedSignal) {
      hardwares = this.props.selectedSignal.hardware.map((hardware, i) => {
        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={hardware.id}
                component={Tech3Radio}
                validate={[required]}
                name="hardware_id"
                idRadio={`hardware_${hardware.id}`}
                radioValue={hardware.id}
                label={hardware.name}
                onChange={(event, newValue, previousValue) => {
                  this.setHardwareId();
                }}
              />
            </div>
          </div>
        );
      });
    }

    if (this.props.selectedHardware) {
      softwares = this.props.selectedHardware.software.map((software, i) => {
        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={software.id}
                component={Tech3Radio}
                validate={[required]}
                name="software_id"
                idRadio={`software_${software.id}`}
                radioValue={software.id}
                label={software.name}
                onChange={(event, newValue, previousValue) => {
                  this.setSoftwareId();
                }}
              />
            </div>
          </div>
        );
      });
    }

    if (this.props.selectedSoftware) {
      versions = this.props.selectedSoftware.versions.map((version, i) => {
        return (
          <div className="singleContainer" key={i}>
            <div className="radio">
              <Field
                key={version.id}
                component={Tech3Radio}
                validate={[required]}
                name="version_id"
                idRadio={`version_${version.id}`}
                radioValue={version.id}
                label={version.name}
              />
            </div>
          </div>
        );
      });
    }
 */
    return (
      <PhotoBoothModal {...this.props}>
        <Form id="addTransformationForm" onSubmit={this.props.handleSubmit}>
          {this.props.initialValues && this.props.initialValues.id ? (
            <h2>Edit Transformation</h2>
          ) : (
            <h2>Create new Transformation</h2>
          )}

          <Field
            label="Select transformation :"
            name="transformations"
            options={transformation_names}
            placeholder="Choose Transformation..."
            component={Tech3Select}
            upward={false}
            validate={[required]}
            onChange={(event, newValue, previousValue) => {
              this.setTransformation(newValue);
            }}
          />

          <Button type="submit" disabled={this.props.submitting}>
            Submit
          </Button>
        </Form>
      </PhotoBoothModal>
    );
  }
}

TransformationForm.propTypes = {
  ...PhotoBoothModal.propTypes
};

TransformationForm.defaultProps = { ...PhotoBoothModal.defaultProps };

const transformationForm = reduxForm({
  form: occurrenceTransformationFormName,
  enableReinitialize: true
})(TransformationForm);

export default connect(
  state => ({
    transformations: state.projects.single.experimentalDesign.transformations
  }),
  dispatch => {
    return {
      changeFieldValue(field, value) {
        dispatch(change(occurrenceTransformationFormName, field, value));
      }
    };
  }
)(transformationForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/TransformationForm.js